import React from 'react'

import {
    StyledBannerMessage,
    StyledLink,
    StyledCTA,
} from 'component-library/banners/LinkBanner/LinkBanner.styled'
import { ThemeMargins } from 'component-library/__styling/settings/metrics'

export interface Props {
    url: string
    message: string
    cta: string
    verticalGutters?: [keyof ThemeMargins, keyof ThemeMargins]
}

export const LinkBanner: React.FC<Props> = ({ url, message, cta, verticalGutters }) => (
    <StyledLink to={url} openExternalInNewWindow={true} verticalGutters={verticalGutters}>
        <StyledBannerMessage>{message}</StyledBannerMessage>
        <StyledCTA>{cta}</StyledCTA>
    </StyledLink>
)
